import { FC } from 'react';
import styled from 'styled-components';

import ScrollPhoneSlides from './ScrollPhoneSlides';

const DesktopSlider: FC<any> = ({
	leftSlides,
	rightSlides,
	wrapperRef,
	activeSlide,
	phoneRef,
	PhoneSlider,
}) => (
	<SliderWrapper ref={wrapperRef}>
		<SliderLeftRow>
			<ScrollPhoneSlides slides={leftSlides} activeSlide={activeSlide} />
		</SliderLeftRow>

		<SliderMobileRow>
			<PhoneSlider activeSlide={activeSlide} phoneRef={phoneRef} />
		</SliderMobileRow>

		<SliderRightRow>
			<ScrollPhoneSlides slides={rightSlides} activeSlide={activeSlide} />
		</SliderRightRow>
	</SliderWrapper>
);

const SliderWrapper = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	justify-content: space-between;

	@media (max-width: 1240px) {
		width: 770px;
		margin: 0 auto;
	}

	@media (max-width: 800px) {
		flex-direction: column;
	}
`;

const SliderLeftRow = styled.div`
	flex-shrink: 0;
	padding-top: 250px;
`;

const SliderRightRow = styled.div`
	padding-top: 600px;
	flex-shrink: 0;
`;

const SliderMobileRow = styled.div`
	flex-grow: 1;
`;

export default DesktopSlider;
